import { __extends } from "tslib";
import { TextEvent } from './TextEvent';
var IMEEvent = /** @class */ (function (_super) {
    __extends(IMEEvent, _super);
    function IMEEvent(type, bubbles, cancelable, text, imeClient) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (text === void 0) { text = ''; }
        if (imeClient === void 0) { imeClient = null; }
        var _this = _super.call(this, type, bubbles, cancelable, text) || this;
        // TODO: coerce
        _this.imeClient = imeClient;
        return _this;
    }
    IMEEvent.classInitializer = null;
    IMEEvent.classSymbols = null;
    IMEEvent.instanceSymbols = null;
    // JS -> AS Bindings
    IMEEvent.IME_COMPOSITION = 'imeComposition';
    IMEEvent.IME_START_COMPOSITION = 'imeStartComposition';
    return IMEEvent;
}(TextEvent));
export { IMEEvent };
